module.exports = __webpack_public_path__ + "img/664de2d.png";